module.exports = __webpack_public_path__ + "static/img/cuc_logo.5833505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cuc_logo.png
// module id = CfBk
// module chunks = 1